const { styles } = require("@superwall-me/tailwind-config")
module.exports = styles
